export enum AppMode {
  Paint = 'paint',
  Analyze = 'analyze',
  Explore = 'explore',
  Report = 'report',
  Manage = 'manage',
  Dashboard = 'dashboard',
}
